import { ICourse } from 'data/entities/course.entity';
import { coursesDatasource } from 'data/datasources/course.datasource';

interface ICourseRepository {
    getCourseByIdOrSlug(idOrSlug: string): Promise<ICourse|null>;
    setLessonCompleted(courseId: string, moduleIndex: number, lessonIndex: number): void;
    syncCourses(idOrSlug: string): Promise<void>;
}

class CourseRepository implements ICourseRepository {

    public setLessonCompleted(courseId: string, moduleIndex: number, lessonIndex: number): void {
        coursesDatasource.setLessonCompleted(courseId, moduleIndex, lessonIndex);
    }

    public getCourseByIdOrSlug(idOrSlug: string): Promise<ICourse|null> {
        return coursesDatasource.getCourseByIdOrSlug(idOrSlug);
    }

    public syncCourses(idOrSlug: string): Promise<void> {
        return coursesDatasource.syncCourses(idOrSlug);
    }

}

export const courseRepository: ICourseRepository = new CourseRepository();
